/* eslint-disable */
export default {
  _1: '1',
  _2: '2',
  _3: '3',
  _4: '4',
  _5: '5',
  _6: '6',
  _7: '7',
  _8: '8',
  _9: '9',
  _10: '10',
  _11: '11',
  _12: '12',
  _13: '13',
  _14: '14',
  _15: '15',
  _16: '16',
  _17: '17',
  _18: '18',
  _19: '19',
  _20: '20',
  _a_name: 'a-name',
  _a: 'a',
  _b_name: 'b-name',
  _b: 'b',
  _best_bonus_time_was: 'best_bonus_time_was',
  _c_name: 'c-name',
  _c: 'c',
  _d_name: 'd-name',
  _d: 'd',
  _e_name: 'e-name',
  _e: 'e',
  _f_name: 'f-name',
  _f: 'f',
  _g_name: 'g-name',
  _g: 'g',
  _good_job: 'good-job',
  _h_name: 'h-name',
  _h: 'h',
  _i_name: 'i-name',
  _i: 'i',
  _j_name: 'j-name',
  _j: 'j',
  _k_name: 'k-name',
  _k: 'k',
  _l_name: 'l-name',
  _l: 'l',
  _m_name: 'm-name',
  _m: 'm',
  _n_name: 'n-name',
  _n: 'n',
  _nice: 'nice',
  _o_name: 'o-name',
  _o: 'o',
  _p_name: 'p-name',
  _p: 'p',
  _pop_in_alphabetical: 'pop_in_alphabetical',
  _pop_instructions: 'pop_instructions',
  _q_name: 'q-name',
  _q: 'q',
  _r_name: 'r-name',
  _r: 'r',
  _s_name: 's-name',
  _s: 's',
  _seconds: 'seconds',
  _t_name: 't-name',
  _t: 't',
  _title: 'title',
  _u_name: 'u-name',
  _u: 'u',
  _v_name: 'v-name',
  _v: 'v',
  _w_name: 'w-name',
  _w: 'w',
  _x_name: 'x-name',
  _x: 'x',
  _y_name: 'y-name',
  _y: 'y',
  _you_did_it_in: 'you_did_it_in',
  _you_did_it: 'you-did-it',
  _z_name: 'z-name',
  _z: 'z',
}